import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { lastValueFrom, Observable } from 'rxjs';
import { UserEntity } from '../../models/entities/user-entity';
import { User } from '../../models/home/sign-up';
import { CustomerEnquiryForm } from '../../models/home/customer-enquiry-form';
import { Log, IShortLogger } from '../logger.service';

@Injectable({
  providedIn: 'root'
})
export class LoginEntityService {
  private readonly logger: IShortLogger<LoginEntityService> = Log.create(LoginEntityService);
  public baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) {
  }
  login(userName: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/v1/users/login/${userName}`);
  }

  async signUp(user: User): Promise<User> {

    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(user);

    this.logger.i('Creating User with body:', body);
    let created = await lastValueFrom(this.http.post(`${this.baseUrl}/v1/users`, body, { headers }));
    return created as User;
  }

  userGetByRole(role: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/v1/users/role/${role}`);
  }


  usersGetByTeam(team: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/v1/users/usersGetByTeam/${team}`);
  }

  async createCustomerEnquiry(customerEnquiry: CustomerEnquiryForm): Promise<CustomerEnquiryForm> {

    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(customerEnquiry);

    this.logger.i('Creating Customer Enquiry with body:', body);
    let created = await lastValueFrom(this.http.post(`${this.baseUrl}/v1/users/createCustomerEnquiry`, body, { headers }));
    return created as CustomerEnquiryForm;
  }

  async getAllCustomerEnquiries(): Promise<any> {

    var res = await lastValueFrom(this.http.get(`${this.baseUrl}/v1/users/getAllCustomerEnquiries`));
    return res;
  }

  assignEnquiryToSalesPerson(objCustomerEnquiry: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(objCustomerEnquiry);
    return this.http.put(`${this.baseUrl}/v1/users/assignEnquiryToSalesPerson`, body, { headers });
  }


  saveConversation(objCustomerEnquiry: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(objCustomerEnquiry);
    return this.http.put(`${this.baseUrl}/v1/users/saveConversation`, body, { headers });
  }

  setEnquiryState(enquiryId: string, status: string) {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(status);
    this.logger.i("enquiryId: ", enquiryId, " status: ", status);
    this.logger.i("Setting enquiry state with body: ", body,headers);
    return this.http.put(`${this.baseUrl}/v1/users/setEnquiryState/${enquiryId}`, body, { headers });
  }

  getBusinessProcessesByUserId(userId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/v1/users/getbusinessprocessesbyuserid/${userId}`);
  }

  async createAdHocUsers(createAdhoc: any): Promise<any> {

    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(createAdhoc);

    this.logger.i("Creating Adhoc users with body: ", body);
    let created = await lastValueFrom(this.http.post(`${this.baseUrl}/v1/users/create-adhoc-users`, body, { headers }));
    return created as any;
  }

  /**
   * Checks whether a naming counter already exists for the given ad-hoc prefix, and returns the
   * current sequence value so the UI can display a "Resuming from #N" indicator.
   */
  checkAdHocPrefix(prefix: string): Observable<{ exists: boolean; currentCount: number }> {
    return this.http.get<{ exists: boolean; currentCount: number }>(
      `${this.baseUrl}/v1/users/adhoc-prefix-check/${encodeURIComponent(prefix)}`
    );
  }

  /**
   * Returns all ad-hoc naming prefixes that have ever been used, together with their current
   * sequence counter values. Used to populate autocomplete suggestions in the participant UI.
   */
  getAdHocPrefixes(): Observable<{ prefix: string; currentCount: number }[]> {
    return this.http.get<{ prefix: string; currentCount: number }[]>(
      `${this.baseUrl}/v1/users/adhoc-prefixes`
    );
  }

}
